import {ApiDatasource} from '../../adapters/io/datasources/ApiDatasource';
import {unwrap} from '../../adapters/io/network/HttpResponse';
import {formatText} from '../../adapters/io/network/utils';
import {ApiDatasourceSpec} from '../../core/datasource';
import {AuthState} from '@okta/okta-auth-js';
import {buildExcelHeader, buildHeader} from './utils/Utils';
import {DatasetStructure} from "../indexes/DatasetIndexes";
import {DiagnosticStructure} from "../indexes/DiagnosticIndexes";

export const getData = <T>(
    authState: AuthState,
    datasource: ApiDatasourceSpec = new ApiDatasource(),
    uriFormatter: (uri: string, ...params: unknown[]) => string = formatText
): Promise<DatasetStructure.DynamicResponse<T>> => {
    const params = new Map();

    return datasource.remote
        .getData<DiagnosticStructure.DynamicResponse<T>>(
            uriFormatter(EndpointDiagnostic.endPoint.concat(EndpointDiagnostic.launchDiagnostic), {}),
            buildHeader(authState),
            params)
        .then(unwrap);
};

export const exportDataToExcel = (
    authState: AuthState,
    ids: string[],
    datasource: ApiDatasourceSpec = new ApiDatasource(),
    uriFormatter: (uri: string, ...params: unknown[]) => string = formatText
): Promise<ArrayBuffer | Error> => {
    const params = new Map();
    const body = ids;

    return datasource.remote
        .getDataExcel(
            uriFormatter(EndpointDiagnostic.endPoint.concat(EndpointDiagnostic.exportDataToExcel), {}),
            body, buildExcelHeader(authState), params
        )
        .then(response => {
            return response;
        });
};

export const EndpointDiagnostic = {
    endPoint: '/end-point',
    launchDiagnostic: '/diagnostic',
    exportDataToExcel: '/diagnostic/export'
};